import { getSchemaPathRequirementMap } from "./_internal/getSchemaPathRequirementMap.js";
const getManager = (control, schema)=>(name, options)=>({
            controlProps: {
                name,
                control,
                ...options
            },
            schemaPathRequirementMap: getSchemaPathRequirementMap(schema),
            value: void 0
        });
export { getManager };
